module.exports = __webpack_public_path__ + "img/smart4.2535b901.png";